<template>
  <svg :height="height" viewBox="0 0 120 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0" y="4" width="32" height="32" rx="8" :fill="colorsComputed.start" />
    <text x="5" y="28" font-family="Inter, sans-serif" font-weight="700" font-size="18" fill="#FFF">Y</text>
    <text x="40" y="28" font-family="Inter, sans-serif" font-weight="700" font-size="20" :fill="colorsComputed.start">
      译了么
    </text>
  </svg>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useColors } from 'vuestic-ui'

const { getColor } = useColors()

const props = withDefaults(
  defineProps<{
    height?: number
    start?: string
  }>(),
  {
    height: 28,
    start: 'primary',
  },
)

const colorsComputed = computed(() => ({
  start: getColor(props.start),
}))
</script>
